import { Component, ChangeDetectionStrategy } from '@angular/core';
import { AdminBaseListComponent } from 'src/modules/sm-base/components/admin-base-list/admin-base-list.component';
import { TableData } from 'src/modules/sm-base/models/table-data.model';
import { TableRow } from 'src/modules/sm-base/models/table-row.model';
import { TableCellType } from 'src/modules/sm-base/netgen/TableCellType';
import { TableColumn } from 'src/modules/sm-base/netgen/TableColumn';
import { Objects } from "src/modules/utils/shared/objects";
import { ProjectPlanningTools } from '../../models/project-planning-tools.model';
import { ProjectCustomFieldDefinition } from '../../netgen/ProjectCustomFieldDefinition';

@Component({
    selector: 'app-edit-project-custom-field-definitions',
    templateUrl: '../../../sm-base/components/admin-base-list/admin-base-list.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditProjectCustomFieldDefinitionsComponent extends AdminBaseListComponent<ProjectCustomFieldDefinition> {
  
    definition = ProjectPlanningTools.definitionProjectCustomFieldDefinition;

    getTable(): TableData {
        return this.app.tTable("entity.ProjectCustomFieldDefinition.fields", new TableData([
            new TableColumn("title", "", TableCellType.string, 50),
            new TableColumn("order", "", TableCellType.int, 3),
            new TableColumn("dropdownField", "", TableCellType.bool, 1)
        ], this.listData.map(o => new TableRow(Objects.toString(o.id), o, o)), ["order", "title"]));
    }
  
}
